import { createMuiTheme } from '@material-ui/core/styles';
import { ApplicantBrandColors } from 'api-clients/monolith';

import { customBorders, customShadows, misc } from './fountain';
import { buildBrandPalette } from './palette';
import { typography } from './typography';

export const buildApplicantBrandedTheme = (colors: ApplicantBrandColors) => {
  return createMuiTheme({
    palette: buildBrandPalette(colors),
    typography,

    /**
     * TODO: We'll need to bring the ripple back and attempt tame it down
     * @see {@link https://fountain.atlassian.net/browse/AX-564}
     */
    props: { MuiButtonBase: { disableRipple: true } },

    /**
     * TODO: We should avoid piggy-backing our own theme props off MUI's,
     * though its safer to bring them over from `fountain-ui-components` and
     * pare them back later
     */
    customBorders,
    customShadows,
    misc,
  });
};
